'use client';

import type {ComponentProps, FC} from 'react';
import clsx from 'clsx';
import Link from 'next/link';
import {usePathname} from 'next/navigation';

export type NavLinkType = {
	type: 'navlink';
	title: string;
	href: string;
	targetBlank?: boolean;
};

type NavLinkProps = {
	link: NavLinkType;
} & Omit<ComponentProps<typeof Link>, 'href' | 'rel'>;

export const NavLink: FC<NavLinkProps> = ({link, className, ...rest}) => {
	const pathname = usePathname();
	const isActive = pathname.includes(link.href);

	return (
		<Link
			href={link.href}
			{...(link.targetBlank ? {rel: 'noopener noreferrer'} : {})}
			className={clsx(
				'inline-block rounded-sm text-xl font-semibold whitespace-nowrap transition-colors hover:underline',
				isActive && 'text-primary hover:text-secondary-dm',
				className,
			)}
			{...rest}
		>
			{link.title}
		</Link>
	);
};
